import { inject } from 'aurelia';
import { SessionService } from './session-service';
import { setShortcodeOverride } from '../environment';

@inject(SessionService)
export class SiteStyleService {
    constructor(private sessionService: SessionService) {}

    loadSiteStyle(websiteShortcode: string) {
        setShortcodeOverride(websiteShortcode);
        import((`../styles/site-styles/${websiteShortcode.toLowerCase()}-styles.scss`));
        this.sessionService.setWebsiteShortcode(websiteShortcode);
        this.handleScrollBarStyling(websiteShortcode);
    }

    handleScrollBarStyling(websiteShortcode: string) {
        const scrollBar = document.querySelector('.page-host');
        if (!scrollBar) return;
        scrollBar.classList.remove(...[...scrollBar.classList].filter(c => c.startsWith('scrollbar-')));
        scrollBar.classList.add(`scrollbar-${websiteShortcode.toLowerCase()}`);
    }
}
